// import React, { useState, useEffect } from "react";
// import { createPortal } from "react-dom";
// import axios from "axios";
// import {
//   RiAddLine,
//   RiSearchLine,
//   RiCloseLine,
//   RiEditLine,
//   RiDeleteBinLine,
//   RiCheckLine,
//   RiErrorWarningLine,
//   RiRefreshLine,
//   RiFileTextLine,
//   RiMapPinLine,
//   RiPhoneLine,
//   RiUserLine,
//   RiShoppingCartLine,
//   RiMoneyDollarCircleLine,
//   RiCalendarLine,
//   RiGiftLine,
//   RiEyeLine,
//   RiBuildingLine,
//   RiBankLine,
//   RiUserStarLine,
//   RiPercentLine,
//   RiStickyNoteLine,
//   RiFileCopyLine,
//   RiPriceTag3Line,
// } from "react-icons/ri";
// import { AiOutlineLoading3Quarters } from "react-icons/ai";
// import { useNavigate } from "react-router-dom";

// const BASE_URL = `${process.env.REACT_APP_API_URL}/buyer`;
// const PRODUCT_URL = `${process.env.REACT_APP_API_URL}/product`;
// const COMPANY_URL = `${process.env.REACT_APP_API_URL}/company/get`;
// const BANK_URL = `${process.env.REACT_APP_API_URL}/bank/get-banks`;

// const defaultForm = {
//   companyId: "", // Main Bank (Buyer) ref
//   bankAddress: "", // auto-filled, not shown
//   bankPhone: "", // auto-filled, not shown
//   userName: "",
//   phone: "",
//   address: "",
//   sellerCompanyId: "",
//   selectedBankAccount: {
//     accountNumber: "",
//     ifscCode: "",
//     branchAddress: "",
//     branchName: "",
//   },
//   selectedQueryContact: {
//     contactPersonName: "",
//     phone: "",
//   },
//   products: [],
//   note: "",
// };

// const defaultOrderedProduct = {
//   productId: "",
//   size: "",
//   pricePerUnit: "",
//   quantity: "",
//   cgstPercentage: "",
//   sgstPercentage: "",
// };

// // ─── Utility Components ───────────────────────────────────────────────────────

// const Spinner = () => (
//   <AiOutlineLoading3Quarters className="animate-spin w-4 h-4" />
// );

// const Toast = ({ message, type, onClose }) => {
//   useEffect(() => {
//     const t = setTimeout(onClose, 3500);
//     return () => clearTimeout(t);
//   }, [onClose]);
//   return (
//     <div
//       className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
//       ${
//         type === "success"
//           ? "bg-emerald-50 border border-emerald-200 text-emerald-800"
//           : "bg-red-50 border border-red-200 text-red-800"
//       }`}
//     >
//       {type === "success" ? (
//         <RiCheckLine className="w-4 h-4 text-emerald-500" />
//       ) : (
//         <RiErrorWarningLine className="w-4 h-4 text-red-500" />
//       )}
//       <span>{message}</span>
//       <button
//         onClick={onClose}
//         className="ml-2 opacity-50 hover:opacity-100 transition"
//       >
//         <RiCloseLine className="w-4 h-4" />
//       </button>
//     </div>
//   );
// };

// const Modal = ({ title, onClose, children, size = "md" }) =>
//   createPortal(
//     <div className="fixed inset-0 z-40 flex items-center justify-center">
//       <div
//         className="absolute inset-0 bg-blue-950/40 backdrop-blur-sm"
//         onClick={onClose}
//       />
//       <div
//         className={`relative z-10 w-full ${
//           size === "lg" ? "max-w-4xl" : "max-w-2xl"
//         } mx-4 bg-white border border-blue-100 rounded-2xl shadow-2xl overflow-hidden`}
//       >
//         <div className="flex items-center justify-between px-6 py-4 border-b border-blue-100 bg-blue-50">
//           <h2 className="text-base font-semibold text-blue-900 flex items-center gap-2">
//             {title}
//           </h2>
//           <button
//             onClick={onClose}
//             className="text-blue-400 hover:text-blue-700 transition rounded-lg p-1 hover:bg-blue-100"
//           >
//             <RiCloseLine className="w-5 h-5" />
//           </button>
//         </div>
//         <div className="p-6 max-h-[80vh] overflow-y-auto bg-white">
//           {children}
//         </div>
//       </div>
//     </div>,
//     document.body,
//   );

// const Field = ({
//   label,
//   name,
//   value,
//   onChange,
//   type = "text",
//   placeholder,
//   as = "input",
//   icon: Icon,
//   required,
// }) => {
//   const DefaultIcon = Icon || RiFileTextLine;
//   return (
//     <div className="flex flex-col gap-1.5">
//       <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//         {label} {required && <span className="text-red-500">*</span>}
//       </label>
//       <div className="relative">
//         <DefaultIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300 pointer-events-none" />
//         {as === "textarea" ? (
//           <textarea
//             name={name}
//             value={value}
//             onChange={onChange}
//             placeholder={placeholder || label}
//             rows={3}
//             className="w-full bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition resize-none"
//           />
//         ) : (
//           <input
//             type={type}
//             name={name}
//             value={value}
//             onChange={onChange}
//             placeholder={placeholder || label}
//             className="w-full bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// const SelectField = ({
//   label,
//   icon: Icon,
//   value,
//   onChange,
//   disabled,
//   children,
//   required,
// }) => (
//   <div>
//     <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest mb-1.5 block">
//       {label} {required && <span className="text-red-500">*</span>}
//     </label>
//     <div className="relative">
//       {Icon && (
//         <Icon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300 pointer-events-none" />
//       )}
//       <select
//         value={value}
//         onChange={onChange}
//         disabled={disabled}
//         className="w-full bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition appearance-none cursor-pointer disabled:opacity-50"
//       >
//         {children}
//       </select>
//     </div>
//   </div>
// );

// const OrderedProductField = ({
//   item,
//   onChange,
//   onRemove,
//   index,
//   allProducts,
// }) => {
//   const selectedProduct = allProducts.find((p) => p._id === item.productId);
//   const availableSizes = selectedProduct?.variations?.map((v) => v.size) || [];
//   const selectedVariation = selectedProduct?.variations?.find(
//     (v) => v.size === item.size,
//   );

//   // Use item.pricePerUnit (editable) — falls back to variation price
//   const pricePerUnit = parseFloat(item.pricePerUnit) || 0;
//   const quantity = item.quantity || 0;
//   const cgst = parseFloat(item.cgstPercentage) || 0;
//   const sgst = parseFloat(item.sgstPercentage) || 0;

//   const taxableAmount = pricePerUnit * quantity;
//   const cgstAmount = (taxableAmount * cgst) / 100;
//   const sgstAmount = (taxableAmount * sgst) / 100;
//   const totalAmount = taxableAmount + cgstAmount + sgstAmount;

//   return (
//     <div className="bg-blue-50/30 border border-blue-100 rounded-lg p-4 mb-3">
//       <div className="flex items-center justify-between mb-3">
//         <h4 className="text-sm font-semibold text-slate-700">
//           Item {index + 1}
//         </h4>
//         {onRemove && (
//           <button
//             type="button"
//             onClick={onRemove}
//             className="text-red-500 hover:text-red-700 transition"
//           >
//             <RiDeleteBinLine className="w-4 h-4" />
//           </button>
//         )}
//       </div>

//       {/* Product + Size row */}
//       <div className="grid grid-cols-2 gap-3 mb-3">
//         <select
//           value={item.productId || ""}
//           onChange={(e) =>
//             onChange({
//               ...item,
//               productId: e.target.value,
//               size: "",
//               pricePerUnit: "",
//             })
//           }
//           className="bg-white border border-blue-200 rounded-lg px-3 py-2 text-sm text-slate-800 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition appearance-none cursor-pointer"
//         >
//           <option value="">Select Product</option>
//           {allProducts.map((p) => (
//             <option key={p._id} value={p._id}>
//               {p.name}
//             </option>
//           ))}
//         </select>

//         <select
//           value={item.size || ""}
//           onChange={(e) => {
//             const newSize = e.target.value;
//             const variation = selectedProduct?.variations?.find(
//               (v) => v.size === newSize,
//             );
//             onChange({
//               ...item,
//               size: newSize,
//               pricePerUnit: variation?.price ?? "",
//             });
//           }}
//           disabled={!item.productId}
//           className="bg-white border border-blue-200 rounded-lg px-3 py-2 text-sm text-slate-800 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition appearance-none cursor-pointer disabled:opacity-50"
//         >
//           <option value="">Select Size</option>
//           {availableSizes.map((s) => (
//             <option key={s} value={s}>
//               {s}
//             </option>
//           ))}
//         </select>
//       </div>

//       {/* Editable Price per piece — auto-filled from product, user can override */}
//       {item.productId && item.size && (
//         <div className="mb-3">
//           <label className="text-xs font-semibold text-indigo-600 uppercase tracking-widest mb-1.5 block">
//             Price / Piece (₹)
//             {selectedVariation?.price &&
//               parseFloat(item.pricePerUnit) !== selectedVariation.price && (
//                 <span className="ml-2 text-[10px] font-normal text-amber-500 normal-case tracking-normal">
//                   (original: ₹{selectedVariation.price})
//                 </span>
//               )}
//           </label>
//           <div className="relative">
//             <RiPriceTag3Line className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-indigo-300 pointer-events-none" />
//             <input
//               type="number"
//               min="0"
//               value={item.pricePerUnit}
//               onChange={(e) =>
//                 onChange({ ...item, pricePerUnit: e.target.value })
//               }
//               placeholder="Enter price"
//               className="w-full bg-indigo-50/60 border border-indigo-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 placeholder-indigo-300 focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 transition"
//             />
//           </div>
//         </div>
//       )}

//       {/* Quantity + CGST + SGST */}
//       <div className="grid grid-cols-3 gap-3 mb-3">
//         <input
//           type="number"
//           placeholder="Quantity"
//           value={item.quantity || ""}
//           onChange={(e) =>
//             onChange({ ...item, quantity: parseInt(e.target.value) || 0 })
//           }
//           className="bg-white border border-blue-200 rounded-lg px-3 py-2 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
//         />
//         <div className="relative">
//           <RiPercentLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300" />
//           <input
//             type="number"
//             placeholder="CGST %"
//             value={item.cgstPercentage}
//             onChange={(e) =>
//               onChange({ ...item, cgstPercentage: e.target.value })
//             }
//             className="w-full bg-white border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
//           />
//         </div>
//         <div className="relative">
//           <RiPercentLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300" />
//           <input
//             type="number"
//             placeholder="SGST %"
//             value={item.sgstPercentage}
//             onChange={(e) =>
//               onChange({ ...item, sgstPercentage: e.target.value })
//             }
//             className="w-full bg-white border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
//           />
//         </div>
//       </div>

//       {/* Line totals — shown when all three fields filled */}
//       {item.productId && item.size && item.quantity > 0 && (
//         <div className="bg-white rounded-lg p-3 border border-blue-100">
//           <div className="grid grid-cols-4 gap-2 text-xs">
//             <div>
//               <span className="text-slate-400">Taxable:</span>
//               <p className="font-semibold text-slate-700">
//                 ₹{taxableAmount.toLocaleString()}
//               </p>
//             </div>
//             <div>
//               <span className="text-slate-400">CGST ({cgst}%):</span>
//               <p className="font-semibold text-emerald-600">
//                 ₹{cgstAmount.toLocaleString()}
//               </p>
//             </div>
//             <div>
//               <span className="text-slate-400">SGST ({sgst}%):</span>
//               <p className="font-semibold text-emerald-600">
//                 ₹{sgstAmount.toLocaleString()}
//               </p>
//             </div>
//             <div>
//               <span className="text-slate-400">Line Total:</span>
//               <p className="font-bold text-blue-600">
//                 ₹{totalAmount.toLocaleString()}
//               </p>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// // ─── Main Component ───────────────────────────────────────────────────────────

// export default function Buyers() {
//   const [orders, setOrders] = useState([]);
//   const [allProducts, setAllProducts] = useState([]);
//   const [banks, setBanks] = useState([]);
//   const [companies, setCompanies] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [actionLoading, setActionLoading] = useState(false);
//   const [modal, setModal] = useState(null);
//   const [selected, setSelected] = useState(null);
//   const [form, setForm] = useState(defaultForm);
//   const [toast, setToast] = useState(null);
//   const [search, setSearch] = useState("");
//   const navigate = useNavigate();

//   const notify = (message, type = "success") => setToast({ message, type });

//   // ── Fetchers ──────────────────────────────────────────────────────────────

//   const fetchOrders = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(`${BASE_URL}/get-all`);
//       setOrders(res.data?.data || res.data?.orders || []);
//     } catch {
//       notify("Failed to fetch orders", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchAllProducts = async () => {
//     try {
//       const res = await axios.get(`${PRODUCT_URL}/all`);
//       setAllProducts(res.data?.products || res.data?.data || res.data || []);
//     } catch (err) {
//       console.error("Failed to fetch products:", err);
//     }
//   };

//   const fetchBanks = async () => {
//     try {
//       const res = await axios.get(BANK_URL);
//       setBanks(res.data?.data || res.data || []);
//     } catch (err) {
//       console.error("Failed to fetch banks:", err);
//     }
//   };

//   const fetchCompanies = async () => {
//     try {
//       const res = await axios.get(COMPANY_URL);
//       const data = res?.data?.data;
//       // Backend returns single object (singleton) — wrap in array
//       setCompanies(Array.isArray(data) ? data : data ? [data] : []);
//     } catch (err) {
//       console.error("Failed to fetch companies:", err);
//     }
//   };

//   useEffect(() => {
//     fetchOrders();
//     fetchAllProducts();
//     fetchBanks();
//     fetchCompanies();
//   }, []);

//   // ── Helpers ───────────────────────────────────────────────────────────────

//   const calculateGrandTotal = (products) => {
//     let subtotal = 0,
//       totalCgst = 0,
//       totalSgst = 0;
//     products.forEach((item) => {
//       const product = allProducts.find((p) => p._id === item.productId);
//       const variation = product?.variations?.find((v) => v.size === item.size);
//       const price = variation?.price || 0;
//       const qty = item.quantity || 0;
//       const cgst = parseFloat(item.cgstPercentage) || 0;
//       const sgst = parseFloat(item.sgstPercentage) || 0;
//       const taxable = price * qty;
//       subtotal += taxable;
//       totalCgst += (taxable * cgst) / 100;
//       totalSgst += (taxable * sgst) / 100;
//     });
//     return {
//       subtotal,
//       totalCgst,
//       totalSgst,
//       grandTotal: subtotal + totalCgst + totalSgst,
//     };
//   };

//   const selectedSellerCompany = companies.find(
//     (c) => c._id === form.sellerCompanyId,
//   );

//   // ── Modal Openers ─────────────────────────────────────────────────────────

//   const openCreate = () => {
//     setForm({
//       ...defaultForm,
//       products: [{ ...defaultOrderedProduct }],
//     });
//     setModal("create");
//   };

//   const openEdit = (order) => {
//     setSelected(order);
//     const bank = banks.find(
//       (b) => b._id === (order.companyId?._id || order.companyId),
//     );
//     setForm({
//       companyId: order.companyId?._id || order.companyId || "",
//       bankAddress: bank?.address || "",
//       bankPhone: bank?.phone || "",
//       userName: order.userName || "",
//       phone: order.phone || "",
//       address: order.address || "",
//       sellerCompanyId:
//         order.sellerCompanyId?._id || order.sellerCompanyId || "",
//       selectedBankAccount: order.selectedBankAccount || {
//         accountNumber: "",
//         ifscCode: "",
//         branchAddress: "",
//         branchName: "",
//       },
//       selectedQueryContact: order.selectedQueryContact || {
//         contactPersonName: "",
//         phone: "",
//       },
//       products: order.products?.map((p) => ({
//         productId: p.productId?._id || p.productId || "",
//         size: p.size || "",
//         quantity: p.quantity || "",
//         cgstPercentage: p.cgstPercentage,
//         sgstPercentage: p.sgstPercentage,
//       })) || [{ ...defaultOrderedProduct }],
//       note: order.note || "",
//     });
//     setModal("edit");
//   };

//   const openDelete = (order) => {
//     setSelected(order);
//     setModal("delete");
//   };

//   const closeModal = () => {
//     setModal(null);
//     setSelected(null);
//   };

//   // ── Form Handlers ─────────────────────────────────────────────────────────

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     // When Main Bank changes → auto-fill phone + address fields from bank data
//     if (name === "companyId") {
//       const bank = banks.find((b) => b._id === value);
//       setForm((f) => ({
//         ...f,
//         companyId: value,
//         phone: bank?.phone || "",
//         address: bank?.address || "",
//         bankAddress: bank?.address || "",
//         bankPhone: bank?.phone || "",
//       }));
//       return;
//     }

//     // When Seller Company changes → reset bank account & query contact
//     if (name === "sellerCompanyId") {
//       setForm((f) => ({
//         ...f,
//         sellerCompanyId: value,
//         selectedBankAccount: {
//           accountNumber: "",
//           ifscCode: "",
//           branchAddress: "",
//           branchName: "",
//         },
//         selectedQueryContact: { contactPersonName: "", phone: "" },
//       }));
//       return;
//     }

//     setForm((f) => ({ ...f, [name]: value }));
//   };

//   const handleBankAccountChange = (e) => {
//     const bankAccount = selectedSellerCompany?.bankDetails?.find(
//       (b) => b.accountNumber === e.target.value,
//     );
//     if (bankAccount) {
//       setForm((f) => ({ ...f, selectedBankAccount: bankAccount }));
//     }
//   };

//   const handleQueryContactChange = (e) => {
//     const queryContact = selectedSellerCompany?.queryDetails?.find(
//       (q) => q.contactPersonName === e.target.value,
//     );
//     if (queryContact) {
//       setForm((f) => ({ ...f, selectedQueryContact: queryContact }));
//     }
//   };

//   const handleProductItemChange = (index, item) => {
//     setForm((f) => {
//       const newProducts = [...f.products];
//       newProducts[index] = item;
//       return { ...f, products: newProducts };
//     });
//   };

//   const handleAddProductItem = () =>
//     setForm((f) => ({
//       ...f,
//       products: [...f.products, { ...defaultOrderedProduct }],
//     }));

//   const handleRemoveProductItem = (index) =>
//     setForm((f) => ({
//       ...f,
//       products: f.products.filter((_, i) => i !== index),
//     }));

//   // ── CRUD ──────────────────────────────────────────────────────────────────

//   const handleCreate = async () => {
//     if (
//       !form.companyId ||
//       !form.userName.trim() ||
//       !form.phone.trim() ||
//       !form.address.trim() ||
//       !form.sellerCompanyId ||
//       !form.selectedBankAccount.accountNumber ||
//       form.products.length === 0
//     ) {
//       notify("Please fill all required fields", "error");
//       return;
//     }

//     const { grandTotal } = calculateGrandTotal(form.products);
//     if (grandTotal === 0) {
//       notify("Please add valid products with quantities", "error");
//       return;
//     }

//     setActionLoading(true);
//     try {
//       await axios.post(`${BASE_URL}/create`, form);
//       notify("Order created successfully");
//       fetchOrders();
//       closeModal();
//     } catch (error) {
//       notify(
//         error?.response?.data?.message || "Failed to create order",
//         "error",
//       );
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const handleUpdate = async () => {
//     if (!form.userName.trim() || !form.phone.trim() || !form.address.trim()) {
//       notify("Please fill all required fields", "error");
//       return;
//     }
//     setActionLoading(true);
//     try {
//       await axios.put(`${BASE_URL}/update/${selected._id}`, {
//         userName: form.userName,
//         phone: form.phone,
//         address: form.address,
//         note: form.note,
//       });
//       notify("Order updated successfully");
//       fetchOrders();
//       closeModal();
//     } catch (error) {
//       notify(
//         error?.response?.data?.message || "Failed to update order",
//         "error",
//       );
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const handleDelete = async () => {
//     setActionLoading(true);
//     try {
//       await axios.delete(`${BASE_URL}/delete/${selected._id}`);
//       notify("Order deleted successfully");
//       fetchOrders();
//       closeModal();
//     } catch {
//       notify("Failed to delete order", "error");
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const filtered = orders.filter(
//     (o) =>
//       (o.userName || "").toLowerCase().includes(search.toLowerCase()) ||
//       (o.phone || "").toLowerCase().includes(search.toLowerCase()) ||
//       (o.address || "").toLowerCase().includes(search.toLowerCase()) ||
//       (o.invoiceNumber || "").toLowerCase().includes(search.toLowerCase()),
//   );

//   const totals = calculateGrandTotal(form.products);

//   // ── Render ────────────────────────────────────────────────────────────────

//   return (
//     <div className="min-h-screen bg-white text-slate-800">
//       {/* Header */}
//       <header className="bg-white border-b border-blue-100 sticky top-0 z-30 shadow-sm">
//         <div className="w-full mx-auto px-6 py-3.5 flex items-center justify-between gap-4 flex-wrap">
//           <div className="flex items-center gap-3">
//             <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center text-white shadow-md shadow-blue-200">
//               <RiShoppingCartLine className="w-5 h-5" />
//             </div>
//             <div>
//               <h1 className="text-base font-bold text-blue-800 tracking-tight">
//                 Order Management
//               </h1>
//               <p className="text-[11px] text-blue-400 tracking-widest uppercase">
//                 Orders & Invoices
//               </p>
//             </div>
//           </div>

//           <div className="flex items-center gap-3">
//             <div className="relative">
//               <RiSearchLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-400" />
//               <input
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//                 placeholder="Search orders..."
//                 className="bg-blue-50 border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-700 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 w-52 transition"
//               />
//             </div>
//             <button
//               onClick={fetchOrders}
//               disabled={loading}
//               title="Refresh"
//               className="w-9 h-9 flex items-center justify-center rounded-lg border border-blue-200 text-blue-400 hover:text-blue-600 hover:bg-blue-50 transition disabled:opacity-50"
//             >
//               <RiRefreshLine
//                 className={`w-4 h-4 ${loading ? "animate-spin" : ""}`}
//               />
//             </button>
//             <button
//               onClick={openCreate}
//               className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold text-sm px-4 py-2 rounded-lg transition-all shadow-md shadow-blue-200"
//             >
//               <RiAddLine className="w-4 h-4" /> Create Order
//             </button>
//           </div>
//         </div>
//       </header>

//       {/* Table */}
//       <div className="w-full mx-auto px-6 pt-6 pb-10">
//         <div className="bg-white border border-blue-100 rounded-2xl overflow-hidden shadow-sm">
//           <div className="px-5 py-3.5 border-b border-blue-50 bg-blue-50/50 flex items-center justify-between">
//             <span className="text-sm font-semibold text-blue-800 flex items-center gap-2">
//               <RiShoppingCartLine className="w-4 h-4 text-blue-500" /> All
//               Orders
//             </span>
//             <span className="text-xs text-blue-400">
//               {filtered.length} record{filtered.length !== 1 ? "s" : ""}
//             </span>
//           </div>
//           <div className="overflow-x-auto">
//             <table className="w-full text-sm">
//               <thead>
//                 <tr className="border-b border-blue-100 bg-blue-50/30">
//                   {[
//                     [RiFileCopyLine, "Invoice No"],
//                     [RiUserLine, "Customer"],
//                     [RiPhoneLine, "Phone"],
//                     [RiBankLine, "Bank"],
//                     [RiBuildingLine, "Seller Co."],
//                     [RiGiftLine, "Items"],
//                     [RiMoneyDollarCircleLine, "Total"],
//                     [RiCalendarLine, "Date"],
//                     [null, "Actions"],
//                   ].map(([Icon, label], i) => (
//                     <th key={i} className="px-4 py-3 text-left">
//                       <span className="flex items-center gap-1.5 text-xs font-semibold text-blue-500 uppercase tracking-widest">
//                         {Icon && <Icon className="w-3.5 h-3.5" />} {label}
//                       </span>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {loading ? (
//                   <tr>
//                     <td colSpan={9} className="py-20 text-center">
//                       <div className="flex flex-col items-center gap-3 text-blue-400">
//                         <AiOutlineLoading3Quarters className="w-7 h-7 animate-spin text-blue-500" />
//                         <span className="text-sm">Loading orders…</span>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : filtered.length === 0 ? (
//                   <tr>
//                     <td colSpan={9} className="py-20 text-center">
//                       <div className="flex flex-col items-center gap-3">
//                         <div className="w-14 h-14 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center">
//                           <RiShoppingCartLine className="w-7 h-7 text-blue-300" />
//                         </div>
//                         <span className="text-sm text-slate-400">
//                           {search
//                             ? "No orders match your search."
//                             : "No orders found. Create one to get started."}
//                         </span>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : (
//                   filtered.map((order, i) => (
//                     <tr
//                       key={order._id || i}
//                       className="border-b border-blue-50 hover:bg-blue-50/50 transition group"
//                     >
//                       <td className="px-4 py-3 font-mono text-xs font-semibold text-blue-600 whitespace-nowrap">
//                         {order.invoiceNumber || "—"}
//                       </td>
//                       <td className="px-4 py-3 font-semibold text-slate-800 whitespace-nowrap">
//                         {order.userName || "—"}
//                       </td>
//                       <td className="px-4 py-3 text-slate-600 whitespace-nowrap">
//                         {order.phone || "—"}
//                       </td>
//                       <td className="px-4 py-3 text-slate-600 whitespace-nowrap text-xs">
//                         {order.companyId?.bankName || "—"}
//                       </td>
//                       <td className="px-4 py-3 text-slate-600 whitespace-nowrap text-xs">
//                         {order.sellerCompanyId?.companyName || "—"}
//                       </td>
//                       <td className="px-4 py-3">
//                         <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-50 border border-blue-200 rounded-lg">
//                           <RiGiftLine className="w-3.5 h-3.5 text-blue-500" />
//                           <span className="text-xs font-semibold text-blue-700">
//                             {order.products?.length || 0}
//                           </span>
//                         </div>
//                       </td>
//                       <td className="px-4 py-3 font-semibold text-slate-700 whitespace-nowrap">
//                         ₹{order.grandTotal?.toLocaleString() || "0"}
//                       </td>
//                       <td className="px-4 py-3 text-slate-400 whitespace-nowrap text-xs">
//                         {new Date(order.createdAt).toLocaleDateString("en-GB", {
//                           day: "2-digit",
//                           month: "short",
//                           year: "numeric",
//                         })}
//                       </td>
//                       <td className="px-4 py-3">
//                         <div className="flex gap-2">
//                           <button
//                             onClick={() =>
//                               navigate(
//                                 `/admin/vendor/buyer-data-details/${order._id}`,
//                               )
//                             }
//                             className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-emerald-50 border border-emerald-200 text-emerald-600 hover:bg-emerald-100 font-semibold transition"
//                           >
//                             <RiEyeLine className="w-3.5 h-3.5" /> View
//                           </button>
//                           <button
//                             onClick={() => openEdit(order)}
//                             className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 font-semibold transition"
//                           >
//                             <RiEditLine className="w-3.5 h-3.5" /> Edit
//                           </button>
//                           <button
//                             onClick={() => openDelete(order)}
//                             className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-red-50 border border-red-200 text-red-500 hover:bg-red-100 font-semibold transition"
//                           >
//                             <RiDeleteBinLine className="w-3.5 h-3.5" /> Delete
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       {/* ── Create Modal ── */}
//       {modal === "create" && (
//         <Modal title="Create New Order" onClose={closeModal} size="lg">
//           <div className="space-y-4">
//             {/* ── 1. Main Bank (Buyer) — TOP ── */}
//             <SelectField
//               label="Main Bank (Buyer)"
//               icon={RiBankLine}
//               value={form.companyId}
//               onChange={(e) =>
//                 handleChange({
//                   target: { name: "companyId", value: e.target.value },
//                 })
//               }
//               required
//             >
//               <option value="">Select Bank</option>
//               {banks.map((b) => (
//                 <option key={b._id} value={b._id}>
//                   {b.bankName}
//                 </option>
//               ))}
//             </SelectField>
//             {/*
//               bankAddress and bankPhone are stored silently in form state
//               (form.bankAddress / form.bankPhone) and sent with the payload.
//               They are intentionally NOT rendered as visible fields.
//             */}

//             {/* ── 2. Customer Name + Bank Phone (auto-filled) ── */}
//             <div className="grid grid-cols-2 gap-4">
//               <Field
//                 label="Customer Name"
//                 name="userName"
//                 value={form.userName}
//                 onChange={handleChange}
//                 icon={RiUserLine}
//                 required
//               />
//               <Field
//                 label="Bank Phone"
//                 name="phone"
//                 value={form.phone}
//                 onChange={handleChange}
//                 icon={RiPhoneLine}
//                 required
//               />
//             </div>
//             <Field
//               label="Bank Address"
//               name="address"
//               value={form.address}
//               onChange={handleChange}
//               icon={RiMapPinLine}
//               as="textarea"
//               required
//             />

//             {/* ── 3. Seller Company ── */}
//             <SelectField
//               label="Seller Company"
//               icon={RiBuildingLine}
//               value={form.sellerCompanyId}
//               onChange={(e) =>
//                 handleChange({
//                   target: { name: "sellerCompanyId", value: e.target.value },
//                 })
//               }
//               required
//             >
//               <option value="">Select Company</option>
//               {companies.map((c) => (
//                 <option key={c._id} value={c._id}>
//                   {c.companyName}
//                 </option>
//               ))}
//             </SelectField>

//             {/* ── 4. Bank Account + Query Contact (depends on sellerCompanyId) ── */}
//             <div className="grid grid-cols-2 gap-4">
//               <SelectField
//                 label="Bank Account"
//                 icon={RiBankLine}
//                 value={form.selectedBankAccount.accountNumber}
//                 onChange={handleBankAccountChange}
//                 disabled={!form.sellerCompanyId}
//                 required
//               >
//                 <option value="">Select Bank Account</option>
//                 {selectedSellerCompany?.bankDetails?.map((bank, idx) => (
//                   <option key={idx} value={bank.accountNumber}>
//                     {bank.accountNumber} — {bank.ifscCode}
//                   </option>
//                 ))}
//               </SelectField>

//               <SelectField
//                 label="Query Contact (Optional)"
//                 icon={RiUserStarLine}
//                 value={form.selectedQueryContact.contactPersonName}
//                 onChange={handleQueryContactChange}
//                 disabled={!form.sellerCompanyId}
//               >
//                 <option value="">Select Contact</option>
//                 {selectedSellerCompany?.queryDetails?.map((contact, idx) => (
//                   <option key={idx} value={contact.contactPersonName}>
//                     {contact.contactPersonName} — {contact.phone}
//                   </option>
//                 ))}
//               </SelectField>
//             </div>

//             {/* Selected bank account preview */}
//             {form.selectedBankAccount.accountNumber && (
//               <div className="bg-blue-50 border border-blue-100 rounded-lg px-4 py-3 text-xs text-slate-600 flex gap-6">
//                 <span>
//                   <span className="font-semibold text-blue-700">Account:</span>{" "}
//                   {form.selectedBankAccount.accountNumber}
//                 </span>
//                 <span>
//                   <span className="font-semibold text-blue-700">IFSC:</span>{" "}
//                   {form.selectedBankAccount.ifscCode}
//                 </span>
//                 {form.selectedBankAccount.branchName && (
//                   <span>
//                     <span className="font-semibold text-blue-700">Branch:</span>{" "}
//                     {form.selectedBankAccount.branchName}
//                   </span>
//                 )}
//               </div>
//             )}

//             {/* ── 5. Products ── */}
//             <div className="border-t border-blue-100 pt-4">
//               <div className="flex items-center justify-between mb-3">
//                 <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//                   Products
//                 </label>
//                 <button
//                   type="button"
//                   onClick={handleAddProductItem}
//                   className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 font-semibold transition"
//                 >
//                   <RiAddLine className="w-3.5 h-3.5" /> Add Product
//                 </button>
//               </div>
//               {form.products.map((item, idx) => (
//                 <OrderedProductField
//                   key={idx}
//                   index={idx}
//                   item={item}
//                   onChange={(v) => handleProductItemChange(idx, v)}
//                   onRemove={() => handleRemoveProductItem(idx)}
//                   allProducts={allProducts}
//                 />
//               ))}
//             </div>

//             {/* ── 6. Note ── */}
//             <Field
//               label="Note (Optional)"
//               name="note"
//               value={form.note}
//               onChange={handleChange}
//               icon={RiStickyNoteLine}
//               as="textarea"
//             />

//             {/* ── 7. Order Summary ── */}
//             {form.products.some(
//               (p) => p.productId && p.size && p.quantity > 0,
//             ) && (
//               <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
//                 <h4 className="font-semibold text-slate-700 mb-2">
//                   Order Summary
//                 </h4>
//                 <div className="space-y-1 text-sm">
//                   <div className="flex justify-between">
//                     <span className="text-slate-500">Subtotal:</span>
//                     <span className="font-semibold">
//                       ₹{totals.subtotal.toLocaleString()}
//                     </span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-slate-500">Total CGST:</span>
//                     <span className="font-semibold text-emerald-600">
//                       ₹{totals.totalCgst.toLocaleString()}
//                     </span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-slate-500">Total SGST:</span>
//                     <span className="font-semibold text-emerald-600">
//                       ₹{totals.totalSgst.toLocaleString()}
//                     </span>
//                   </div>
//                   <div className="border-t border-blue-200 pt-2 mt-2 flex justify-between">
//                     <span className="font-semibold text-slate-700">
//                       Grand Total:
//                     </span>
//                     <span className="font-bold text-lg text-blue-600">
//                       ₹{totals.grandTotal.toLocaleString()}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             )}

//             <div className="flex justify-end gap-3 pt-4 border-t border-blue-100">
//               <button
//                 onClick={closeModal}
//                 className="px-5 py-2 rounded-lg text-sm text-slate-500 border border-slate-200 hover:bg-slate-50 transition"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleCreate}
//                 disabled={actionLoading}
//                 className="flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold bg-blue-600 hover:bg-blue-700 text-white transition disabled:opacity-60"
//               >
//                 {actionLoading ? (
//                   <Spinner />
//                 ) : (
//                   <RiCheckLine className="w-4 h-4" />
//                 )}
//                 Create Order
//               </button>
//             </div>
//           </div>
//         </Modal>
//       )}

//       {/* ── Edit Modal ── */}
//       {modal === "edit" && (
//         <Modal
//           title={`Edit Order — ${selected?.invoiceNumber}`}
//           onClose={closeModal}
//           size="md"
//         >
//           <div className="space-y-4">
//             <div className="grid grid-cols-2 gap-4">
//               <Field
//                 label="Customer Name"
//                 name="userName"
//                 value={form.userName}
//                 onChange={handleChange}
//                 icon={RiUserLine}
//               />
//               <Field
//                 label="Phone"
//                 name="phone"
//                 value={form.phone}
//                 onChange={handleChange}
//                 icon={RiPhoneLine}
//               />
//             </div>
//             <Field
//               label="Address"
//               name="address"
//               value={form.address}
//               onChange={handleChange}
//               icon={RiMapPinLine}
//               as="textarea"
//             />
//             <Field
//               label="Note"
//               name="note"
//               value={form.note}
//               onChange={handleChange}
//               icon={RiStickyNoteLine}
//               as="textarea"
//             />

//             <div className="flex justify-end gap-3 pt-4 border-t border-blue-100">
//               <button
//                 onClick={closeModal}
//                 className="px-5 py-2 rounded-lg text-sm text-slate-500 border border-slate-200 hover:bg-slate-50 transition"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleUpdate}
//                 disabled={actionLoading}
//                 className="flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold bg-blue-600 hover:bg-blue-700 text-white transition disabled:opacity-60"
//               >
//                 {actionLoading ? (
//                   <Spinner />
//                 ) : (
//                   <RiCheckLine className="w-4 h-4" />
//                 )}
//                 Save Changes
//               </button>
//             </div>
//           </div>
//         </Modal>
//       )}

//       {/* ── Delete Modal ── */}
//       {modal === "delete" && (
//         <Modal title="Confirm Deletion" onClose={closeModal}>
//           <div className="text-center py-4">
//             <div className="w-16 h-16 rounded-full bg-red-50 border border-red-100 flex items-center justify-center mx-auto mb-4">
//               <RiErrorWarningLine className="w-8 h-8 text-red-500" />
//             </div>
//             <p className="text-slate-700 font-semibold mb-1 text-base">
//               Delete order #{selected?.invoiceNumber}?
//             </p>
//             <p className="text-slate-400 text-sm mb-6">
//               This action cannot be undone. Stock will be restored.
//             </p>
//             <div className="flex justify-center gap-3">
//               <button
//                 onClick={closeModal}
//                 className="px-6 py-2 rounded-lg text-sm text-slate-500 border border-slate-200 hover:bg-slate-50 transition"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleDelete}
//                 disabled={actionLoading}
//                 className="flex items-center gap-2 px-6 py-2 rounded-lg text-sm font-semibold bg-red-500 hover:bg-red-600 text-white transition disabled:opacity-60"
//               >
//                 {actionLoading ? (
//                   <Spinner />
//                 ) : (
//                   <RiDeleteBinLine className="w-4 h-4" />
//                 )}
//                 Delete Order
//               </button>
//             </div>
//           </div>
//         </Modal>
//       )}

//       {toast && <Toast {...toast} onClose={() => setToast(null)} />}
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import axios from "axios";
import {
  RiAddLine,
  RiSearchLine,
  RiCloseLine,
  RiEditLine,
  RiDeleteBinLine,
  RiCheckLine,
  RiErrorWarningLine,
  RiRefreshLine,
  RiFileTextLine,
  RiMapPinLine,
  RiPhoneLine,
  RiUserLine,
  RiShoppingCartLine,
  RiMoneyDollarCircleLine,
  RiCalendarLine,
  RiGiftLine,
  RiEyeLine,
  RiBuildingLine,
  RiBankLine,
  RiUserStarLine,
  RiPercentLine,
  RiStickyNoteLine,
  RiFileCopyLine,
  RiPriceTag3Line,
  RiAlertLine,
} from "react-icons/ri";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { generateInvoicePDF } from "../Util/BuyerPdf";

const BASE_URL = `${process.env.REACT_APP_API_URL}/buyer`;
const PRODUCT_URL = `${process.env.REACT_APP_API_URL}/product`;
const COMPANY_URL = `${process.env.REACT_APP_API_URL}/company/get`;
const BANK_URL = `${process.env.REACT_APP_API_URL}/bank/get-banks`;

const defaultForm = {
  invoiceNumber: "",
  companyId: "",
  bankAddress: "",
  bankPhone: "",
  userName: "",
  phone: "",
  address: "",
  sellerCompanyId: "",
  selectedBankAccount: {
    accountNumber: "",
    ifscCode: "",
    branchAddress: "",
    branchName: "",
  },
  selectedQueryContact: {
    contactPersonName: "",
    phone: "",
  },
  products: [],
  note: "",
};

const defaultOrderedProduct = {
  productId: "",
  size: "",
  pricePerUnit: "",
  quantity: "",
  cgstPercentage: "",
  sgstPercentage: "",
  productType: "",
};

// ─── Utility Components ───────────────────────────────────────────────────────

const Spinner = () => (
  <AiOutlineLoading3Quarters className="animate-spin w-4 h-4" />
);

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const t = setTimeout(onClose, 3500);
    return () => clearTimeout(t);
  }, [onClose]);
  return (
    <div
      className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
      ${
        type === "success"
          ? "bg-emerald-50 border border-emerald-200 text-emerald-800"
          : "bg-red-50 border border-red-200 text-red-800"
      }`}
    >
      {type === "success" ? (
        <RiCheckLine className="w-4 h-4 text-emerald-500" />
      ) : (
        <RiErrorWarningLine className="w-4 h-4 text-red-500" />
      )}
      <span>{message}</span>
      <button
        onClick={onClose}
        className="ml-2 opacity-50 hover:opacity-100 transition"
      >
        <RiCloseLine className="w-4 h-4" />
      </button>
    </div>
  );
};

const Modal = ({ title, onClose, children, size = "md" }) =>
  createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-blue-950/40 backdrop-blur-sm"
        onClick={onClose}
      />
      <div
        className={`relative z-10 w-full ${
          size === "lg" ? "max-w-4xl" : "max-w-2xl"
        } mx-4 bg-white border border-blue-100 rounded-2xl shadow-2xl overflow-hidden`}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-blue-100 bg-blue-50">
          <h2 className="text-base font-semibold text-blue-900 flex items-center gap-2">
            {title}
          </h2>
          <button
            onClick={onClose}
            className="text-blue-400 hover:text-blue-700 transition rounded-lg p-1 hover:bg-blue-100"
          >
            <RiCloseLine className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6 max-h-[80vh] overflow-y-auto bg-white">
          {children}
        </div>
      </div>
    </div>,
    document.body,
  );

const Field = ({
  label,
  name,
  value,
  onChange,
  type = "text",
  placeholder,
  as = "input",
  icon: Icon,
  required,
}) => {
  const DefaultIcon = Icon || RiFileTextLine;
  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <div className="relative">
        <DefaultIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300 pointer-events-none" />
        {as === "textarea" ? (
          <textarea
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder || label}
            rows={3}
            className="w-full bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition resize-none"
          />
        ) : (
          <input
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder || label}
            className="w-full bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
          />
        )}
      </div>
    </div>
  );
};

const SelectField = ({
  label,
  icon: Icon,
  value,
  onChange,
  disabled,
  children,
  required,
}) => (
  <div>
    <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest mb-1.5 block">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <div className="relative">
      {Icon && (
        <Icon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300 pointer-events-none" />
      )}
      <select
        value={value}
        onChange={onChange}
        disabled={disabled}
        className="w-full bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition appearance-none cursor-pointer disabled:opacity-50"
      >
        {children}
      </select>
    </div>
  </div>
);

const OrderedProductField = ({
  item,
  onChange,
  onRemove,
  index,
  allProducts,
}) => {
  const selectedProduct = allProducts.find((p) => p._id === item.productId);
  const productType = selectedProduct?.type;
  const isWithVariation = productType === "withVariation";
  const isWithoutVariation = productType === "withoutVariation";

  const availableSizes = isWithVariation
    ? selectedProduct?.variations?.map((v) => ({
        size: v.size,
        quantity: v.quantity,
        price: v.price,
      })) || []
    : [];

  const selectedVariation = isWithVariation
    ? selectedProduct?.variations?.find((v) => v.size === item.size)
    : null;

  // Default price for display hint only
  let defaultPrice = 0;
  if (isWithoutVariation) {
    defaultPrice = selectedProduct?.price || 0;
  } else if (isWithVariation && selectedVariation) {
    defaultPrice = selectedVariation.price;
  }

  const pricePerUnit = parseFloat(item.pricePerUnit) || 0;
  const quantity = isWithoutVariation ? 1 : parseInt(item.quantity) || 0;
  const cgst = parseFloat(item.cgstPercentage) || 0;
  const sgst = parseFloat(item.sgstPercentage) || 0;

  const taxableAmount = pricePerUnit * quantity;
  const cgstAmount = (taxableAmount * cgst) / 100;
  const sgstAmount = (taxableAmount * sgst) / 100;
  const totalAmount = taxableAmount + cgstAmount + sgstAmount;

  // Get stock information
  const getStockInfo = () => {
    if (isWithVariation && item.size && selectedVariation) {
      const stock = selectedVariation.quantity || 0;
      return {
        available: stock,
        isLow: stock > 0 && stock < 10,
        isOut: stock === 0,
      };
    }
    // withoutVariation: always treat as in-stock
    return { available: Infinity, isLow: false, isOut: false };
  };

  const stockInfo = getStockInfo();

  // Auto-fill price for withoutVariation on product select
  const handleProductChange = (e) => {
    const product = allProducts.find((p) => p._id === e.target.value);
    onChange({
      ...item,
      productId: e.target.value,
      size: "",
      quantity: product?.type === "withoutVariation" ? 1 : "",
      pricePerUnit:
        product?.type === "withoutVariation" ? (product.price ?? "") : "",
      productType: product?.type || "",
    });
  };

  // Handle quantity change with stock validation
  const handleQuantityChange = (e) => {
    const val = parseInt(e.target.value);
    const newQuantity = isNaN(val) ? "" : val;

    // Client-side stock validation
    if (
      newQuantity &&
      stockInfo.available > 0 &&
      newQuantity > stockInfo.available
    ) {
      onChange({
        ...item,
        quantity: newQuantity,
        _stockError: `Only ${stockInfo.available} units available`,
      });
    } else {
      onChange({
        ...item,
        quantity: newQuantity,
        _stockError: null,
      });
    }
  };

  return (
    <div className="bg-blue-50/30 border border-blue-100 rounded-lg p-4 mb-3">
      <div className="flex items-center justify-between mb-3">
        <h4 className="text-sm font-semibold text-slate-700">
          Item {index + 1}
        </h4>
        {onRemove && (
          <button
            type="button"
            onClick={onRemove}
            className="text-red-500 hover:text-red-700 transition"
          >
            <RiDeleteBinLine className="w-4 h-4" />
          </button>
        )}
      </div>

      {/* Product Selection */}
      <div className="grid grid-cols-2 gap-3 mb-3">
        <select
          value={item.productId || ""}
          onChange={handleProductChange}
          className="bg-white border border-blue-200 rounded-lg px-3 py-2 text-sm text-slate-800 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition appearance-none cursor-pointer"
        >
          <option value="">Select Product</option>
          {allProducts.map((p) => (
            <option key={p._id} value={p._id}>
              {p.name}{" "}
              {p.type === "withoutVariation" ? "(Simple)" : "(With Sizes)"}
            </option>
          ))}
        </select>

        {/* Size selector — only for withVariation */}
        {isWithVariation && (
          <select
            value={item.size || ""}
            onChange={(e) => {
              const newSize = e.target.value;
              const variation = selectedProduct?.variations?.find(
                (v) => v.size === newSize,
              );
              onChange({
                ...item,
                size: newSize,
                pricePerUnit: variation?.price ?? "",
                quantity: "", // Reset quantity when size changes
              });
            }}
            disabled={!item.productId}
            className="bg-white border border-blue-200 rounded-lg px-3 py-2 text-sm text-slate-800 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition appearance-none cursor-pointer disabled:opacity-50"
          >
            <option value="">Select Size</option>
            {availableSizes.map((v) => (
              <option key={v.size} value={v.size}>
                {v.size} (Stock: {v.quantity} | ₹{v.price})
              </option>
            ))}
          </select>
        )}

        {/* Simple product stock info */}
        {/* {isWithoutVariation && selectedProduct && (
          <div
            className={`flex items-center px-3 py-2 rounded-lg text-xs ${
              stockInfo.isOut
                ? "bg-red-50 border border-red-200 text-red-700"
                : stockInfo.isLow
                  ? "bg-amber-50 border border-amber-200 text-amber-700"
                  : "bg-emerald-50 border border-emerald-200 text-emerald-700"
            }`}
          >
            <RiAlertLine className="w-4 h-4 mr-2 flex-shrink-0" />
            <span>
              {stockInfo.isOut
                ? "Out of Stock!"
                : stockInfo.isLow
                  ? `Low Stock: Only ${stockInfo.available} left`
                  : `Stock Available: ${stockInfo.available}`}
            </span>
          </div>
        )} */}
      </div>

      {/* Price Field */}
      {item.productId &&
        (isWithoutVariation || (isWithVariation && item.size)) && (
          <div className="mb-3">
            <label className="text-xs font-semibold text-indigo-600 uppercase tracking-widest mb-1.5 block">
              Price / Piece (₹)
              {defaultPrice > 0 &&
                parseFloat(item.pricePerUnit) !== defaultPrice && (
                  <span className="ml-2 text-[10px] font-normal text-amber-500 normal-case tracking-normal">
                    (original: ₹{defaultPrice})
                  </span>
                )}
            </label>
            <div className="relative">
              <RiPriceTag3Line className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-indigo-300 pointer-events-none" />
              <input
                type="number"
                min="0"
                step="0.01"
                value={item.pricePerUnit}
                onChange={(e) =>
                  onChange({ ...item, pricePerUnit: e.target.value })
                }
                placeholder="Enter price"
                className="w-full bg-indigo-50/60 border border-indigo-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 placeholder-indigo-300 focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 transition"
              />
            </div>
          </div>
        )}

      {/* Quantity + GST */}
      <div className="grid grid-cols-3 gap-3 mb-3">
        {isWithVariation && (
          <div className="relative">
            <input
              type="number"
              min="1"
              max={stockInfo.available > 0 ? stockInfo.available : undefined}
              placeholder="Quantity"
              value={item.quantity === "" ? "" : item.quantity}
              onChange={handleQuantityChange}
              disabled={(isWithVariation && stockInfo.isOut) || !item.productId}
              className={`w-full bg-white border rounded-lg px-3 py-2 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:ring-2 transition ${
                stockInfo.isOut
                  ? "border-red-200 bg-red-50 cursor-not-allowed"
                  : "border-blue-200 focus:border-blue-500 focus:ring-blue-500/20"
              }`}
            />
            {item._stockError && (
              <p className="text-xs text-red-500 mt-1">{item._stockError}</p>
            )}
            {stockInfo.isOut && (
              <p className="text-xs text-red-500 mt-1">Product out of stock!</p>
            )}
          </div>
        )}

        <div className="relative">
          <RiPercentLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300" />
          <input
            type="number"
            placeholder="CGST %"
            value={item.cgstPercentage}
            onChange={(e) =>
              onChange({ ...item, cgstPercentage: e.target.value })
            }
            className="w-full bg-white border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
          />
        </div>
        <div className="relative">
          <RiPercentLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300" />
          <input
            type="number"
            placeholder="SGST %"
            value={item.sgstPercentage}
            onChange={(e) =>
              onChange({ ...item, sgstPercentage: e.target.value })
            }
            className="w-full bg-white border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
          />
        </div>
      </div>

      {/* Line Totals */}
      {item.productId && quantity > 0 && pricePerUnit > 0 && (
        <div className="bg-white rounded-lg p-3 border border-blue-100">
          <div className="grid grid-cols-4 gap-2 text-xs">
            <div>
              <span className="text-slate-400">Taxable:</span>
              <p className="font-semibold text-slate-700">
                ₹{taxableAmount.toLocaleString()}
              </p>
            </div>
            <div>
              <span className="text-slate-400">CGST ({cgst}%):</span>
              <p className="font-semibold text-emerald-600">
                ₹{cgstAmount.toLocaleString()}
              </p>
            </div>
            <div>
              <span className="text-slate-400">SGST ({sgst}%):</span>
              <p className="font-semibold text-emerald-600">
                ₹{sgstAmount.toLocaleString()}
              </p>
            </div>
            <div>
              <span className="text-slate-400">Line Total:</span>
              <p className="font-bold text-blue-600">
                ₹{totalAmount.toLocaleString()}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ─── Main Component ───────────────────────────────────────────────────────────

export default function Buyers() {
  const [orders, setOrders] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [banks, setBanks] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [modal, setModal] = useState(null);
  const [selected, setSelected] = useState(null);
  const [form, setForm] = useState(defaultForm);
  const [toast, setToast] = useState(null);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const notify = (message, type = "success") => setToast({ message, type });

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/get-all`);
      setOrders(res.data?.data || res.data?.orders || []);
    } catch {
      notify("Failed to fetch orders", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchAllProducts = async () => {
    try {
      const res = await axios.get(`${PRODUCT_URL}/all`);
      setAllProducts(res.data?.products || res.data?.data || res.data || []);
    } catch (err) {
      console.error("Failed to fetch products:", err);
      notify("Failed to fetch products", "error");
    }
  };

  const fetchBanks = async () => {
    try {
      const res = await axios.get(BANK_URL);
      setBanks(res.data?.data || res.data || []);
    } catch (err) {
      console.error("Failed to fetch banks:", err);
    }
  };

  const fetchCompanies = async () => {
    try {
      const res = await axios.get(COMPANY_URL);
      const data = res?.data?.data;
      setCompanies(Array.isArray(data) ? data : data ? [data] : []);
    } catch (err) {
      console.error("Failed to fetch companies:", err);
    }
  };

  useEffect(() => {
    fetchOrders();
    fetchAllProducts();
    fetchBanks();
    fetchCompanies();
  }, []);

  const calculateGrandTotal = (products) => {
    let subtotal = 0,
      totalCgst = 0,
      totalSgst = 0;
    products.forEach((item) => {
      const price = parseFloat(item.pricePerUnit) || 0;
      const qty = parseInt(item.quantity) || 0;
      const cgst = parseFloat(item.cgstPercentage) || 0;
      const sgst = parseFloat(item.sgstPercentage) || 0;
      const taxable = price * qty;
      subtotal += taxable;
      totalCgst += (taxable * cgst) / 100;
      totalSgst += (taxable * sgst) / 100;
    });
    return {
      subtotal,
      totalCgst,
      totalSgst,
      grandTotal: subtotal + totalCgst + totalSgst,
    };
  };

  const selectedSellerCompany = companies.find(
    (c) => c._id === form.sellerCompanyId,
  );

  const openCreate = () => {
    setForm({
      ...defaultForm,
      products: [{ ...defaultOrderedProduct }],
    });
    setModal("create");
  };
  const openEdit = (order) => {
    setSelected(order);
    // Find bank (if bank object is populated or just an ID)
    const bankId = order.companyId?._id || order.companyId;
    const bank = banks.find((b) => b._id === bankId);

    // Map order products to form product items
    const productItems = order.products?.map((p) => {
      const productId = p.productId?._id || p.productId;
      const product = allProducts.find((prod) => prod._id === productId);
      return {
        productId: productId || "",
        size: p.size || "",
        quantity: p.quantity ?? "",
        cgstPercentage: p.cgstPercentage ?? "",
        sgstPercentage: p.sgstPercentage ?? "",
        pricePerUnit: p.pricePerUnit ?? "",
        productType: product?.type || "",
      };
    }) || [{ ...defaultOrderedProduct }];

    setForm({
      invoiceNumber: order.invoiceNumber || "",
      companyId: bankId || "",
      bankAddress: bank?.address || "",
      bankPhone: bank?.phone || "",
      userName: order.userName || "",
      phone: order.phone || "",
      address: order.address || "",
      sellerCompanyId:
        order.sellerCompanyId?._id || order.sellerCompanyId || "",
      selectedBankAccount: order.selectedBankAccount || {
        accountNumber: "",
        ifscCode: "",
        branchAddress: "",
        branchName: "",
      },
      selectedQueryContact: order.selectedQueryContact || {
        contactPersonName: "",
        phone: "",
      },
      products: productItems,
      note: order.note || "",
    });
    setModal("edit");
  };

  const openDelete = (order) => {
    setSelected(order);
    setModal("delete");
  };

  const closeModal = () => {
    setModal(null);
    setSelected(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "companyId") {
      const bank = banks.find((b) => b._id === value);
      setForm((f) => ({
        ...f,
        companyId: value,
        phone: bank?.phone || "",
        address: bank?.address || "",
        bankAddress: bank?.address || "",
        bankPhone: bank?.phone || "",
      }));
      return;
    }

    if (name === "sellerCompanyId") {
      setForm((f) => ({
        ...f,
        sellerCompanyId: value,
        selectedBankAccount: {
          accountNumber: "",
          ifscCode: "",
          branchAddress: "",
          branchName: "",
        },
        selectedQueryContact: { contactPersonName: "", phone: "" },
      }));
      return;
    }

    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleBankAccountChange = (e) => {
    const bankAccount = selectedSellerCompany?.bankDetails?.find(
      (b) => b.accountNumber === e.target.value,
    );
    if (bankAccount) {
      setForm((f) => ({ ...f, selectedBankAccount: bankAccount }));
    }
  };

  const handleQueryContactChange = (e) => {
    const queryContact = selectedSellerCompany?.queryDetails?.find(
      (q) => q.contactPersonName === e.target.value,
    );
    if (queryContact) {
      setForm((f) => ({ ...f, selectedQueryContact: queryContact }));
    }
  };

  const handleProductItemChange = (index, item) => {
    setForm((f) => {
      const newProducts = [...f.products];
      newProducts[index] = item;
      return { ...f, products: newProducts };
    });
  };

  const handleAddProductItem = () =>
    setForm((f) => ({
      ...f,
      products: [...f.products, { ...defaultOrderedProduct }],
    }));

  const handleRemoveProductItem = (index) =>
    setForm((f) => ({
      ...f,
      products: f.products.filter((_, i) => i !== index),
    }));

  // ── Enhanced validation and order creation ──
  const handleCreate = async () => {
    // Check required fields
    if (!form.invoiceNumber.trim()) {
      notify("Please enter an invoice number", "error");
      return;
    }
    if (
      !form.companyId ||
      !form.userName.trim() ||
      !form.phone.trim() ||
      !form.address.trim() ||
      !form.sellerCompanyId ||
      !form.selectedBankAccount.accountNumber ||
      form.products.length === 0
    ) {
      notify("Please fill all required fields", "error");
      return;
    }

    // Validate each product
    for (let i = 0; i < form.products.length; i++) {
      const item = form.products[i];
      const selectedProduct = allProducts.find((p) => p._id === item.productId);

      // Check if product is selected
      if (!item.productId) {
        notify(`Item ${i + 1}: Please select a product`, "error");
        return;
      }

      // Check if product exists
      if (!selectedProduct) {
        notify(`Item ${i + 1}: Product not found`, "error");
        return;
      }

      // For variation products, check size
      if (selectedProduct.type === "withVariation" && !item.size) {
        notify(
          `Item ${i + 1}: Please select a size for ${selectedProduct.name}`,
          "error",
        );
        return;
      }

      // Check quantity - CRITICAL FIX
      const qty =
        selectedProduct.type === "withoutVariation"
          ? 1
          : parseInt(item.quantity);
      if (
        selectedProduct.type !== "withoutVariation" &&
        (!item.quantity || isNaN(qty) || qty <= 0)
      ) {
        notify(`Item ${i + 1}: Please enter a valid quantity...`, "error");
        return;
      }

      // Check price
      const price = parseFloat(item.pricePerUnit);
      if (!item.pricePerUnit || isNaN(price) || price <= 0) {
        notify(`Item ${i + 1}: Please enter a valid price`, "error");
        return;
      }

      // Check stock availability for simple products
      // if (selectedProduct.type === "withoutVariation") {
      //   if (
      //     selectedProduct.quantity === undefined ||
      //     selectedProduct.quantity === null
      //   ) {
      //     notify(
      //       `Item ${i + 1}: Stock information not available for ${selectedProduct.name}. Please contact administrator.`,
      //       "error",
      //     );
      //     return;
      //   }

      //   if (selectedProduct.quantity < qty) {
      //     notify(
      //       `Item ${i + 1}: Insufficient stock for ${selectedProduct.name}. Available: ${selectedProduct.quantity}, Requested: ${qty}`,
      //       "error",
      //     );
      //     return;
      //   }
      // }

      // Check stock for variation products
      if (selectedProduct.type === "withVariation" && item.size) {
        const variation = selectedProduct.variations?.find(
          (v) => v.size === item.size,
        );
        if (!variation) {
          notify(
            `Item ${i + 1}: Variation ${item.size} not found for ${selectedProduct.name}`,
            "error",
          );
          return;
        }

        if (variation.quantity < qty) {
          notify(
            `Item ${i + 1}: Insufficient stock for ${selectedProduct.name} (${item.size}). Available: ${variation.quantity}, Requested: ${qty}`,
            "error",
          );
          return;
        }
      }
    }

    // Calculate and check grand total
    const { grandTotal } = calculateGrandTotal(form.products);
    if (grandTotal === 0) {
      notify("Please add valid products with quantities", "error");
      return;
    }

    // Submit order
    setActionLoading(true);
    try {
      const payload = {
        ...form,
        products: form.products.map(
          ({ productType, _stockError, ...rest }) => ({
            ...rest,
            quantity: productType === "withoutVariation" ? 1 : rest.quantity,
          }),
        ),
      };

      console.log(
        "Submitting order payload:",
        JSON.stringify(payload, null, 2),
      );

      const response = await axios.post(`${BASE_URL}/create`, payload);

      if (response.data.success) {
        notify("Order created successfully");
        fetchOrders();
        closeModal();
        // Reset form
        setForm(defaultForm);
      } else {
        notify(response.data.message || "Failed to create order", "error");
      }
    } catch (error) {
      console.error("Order creation error:", error);
      notify(
        error?.response?.data?.message ||
          error.message ||
          "Failed to create order",
        "error",
      );
    } finally {
      setActionLoading(false);
    }
  };

  const handleUpdate = async () => {
    // ---- VALIDATION (same as create) ----
    if (
      !form.companyId ||
      !form.userName.trim() ||
      !form.phone.trim() ||
      !form.address.trim() ||
      !form.sellerCompanyId ||
      !form.selectedBankAccount.accountNumber ||
      form.products.length === 0
    ) {
      notify("Please fill all required fields", "error");
      return;
    }

    for (let i = 0; i < form.products.length; i++) {
      const item = form.products[i];
      const selectedProduct = allProducts.find((p) => p._id === item.productId);
      if (!item.productId) {
        notify(`Item ${i + 1}: Please select a product`, "error");
        return;
      }
      if (!selectedProduct) {
        notify(`Item ${i + 1}: Product not found`, "error");
        return;
      }
      if (selectedProduct.type === "withVariation" && !item.size) {
        notify(
          `Item ${i + 1}: Please select a size for ${selectedProduct.name}`,
          "error",
        );
        return;
      }
      const qty =
        selectedProduct.type === "withoutVariation"
          ? 1
          : parseInt(item.quantity);
      if (
        selectedProduct.type !== "withoutVariation" &&
        (!item.quantity || isNaN(qty) || qty <= 0)
      ) {
        notify(`Item ${i + 1}: Please enter a valid quantity`, "error");
        return;
      }
      const price = parseFloat(item.pricePerUnit);
      if (!item.pricePerUnit || isNaN(price) || price <= 0) {
        notify(`Item ${i + 1}: Please enter a valid price`, "error");
        return;
      }
      if (selectedProduct.type === "withVariation" && item.size) {
        const variation = selectedProduct.variations?.find(
          (v) => v.size === item.size,
        );
        if (!variation) {
          notify(`Item ${i + 1}: Variation ${item.size} not found`, "error");
          return;
        }
        if (variation.quantity < qty) {
          notify(
            `Item ${i + 1}: Insufficient stock for ${selectedProduct.name} (${item.size}). Available: ${variation.quantity}`,
            "error",
          );
          return;
        }
      }
    }

    const { grandTotal } = calculateGrandTotal(form.products);
    if (grandTotal === 0) {
      notify("Please add valid products with quantities", "error");
      return;
    }

    // ---- SUBMIT FULL UPDATE ----
    setActionLoading(true);
    try {
      const payload = {
        ...form,
        products: form.products.map(
          ({ productType, _stockError, ...rest }) => ({
            ...rest,
            quantity: productType === "withoutVariation" ? 1 : rest.quantity,
          }),
        ),
      };

      await axios.put(`${BASE_URL}/update/${selected._id}`, payload);

      notify("Order updated successfully");
      fetchOrders();
      closeModal();
    } catch (error) {
      notify(
        error?.response?.data?.message || "Failed to update order",
        "error",
      );
    } finally {
      setActionLoading(false);
    }
  };

  const handleDelete = async () => {
    setActionLoading(true);
    try {
      await axios.delete(`${BASE_URL}/delete/${selected._id}`);
      notify("Order deleted successfully");
      fetchOrders();
      closeModal();
    } catch {
      notify("Failed to delete order", "error");
    } finally {
      setActionLoading(false);
    }
  };

  const filtered = orders.filter(
    (o) =>
      (o.userName || "").toLowerCase().includes(search.toLowerCase()) ||
      (o.phone || "").toLowerCase().includes(search.toLowerCase()) ||
      (o.address || "").toLowerCase().includes(search.toLowerCase()) ||
      (o.invoiceNumber || "").toLowerCase().includes(search.toLowerCase()),
  );

  const totals = calculateGrandTotal(form.products);

  return (
    <div className="min-h-screen bg-white text-slate-800">
      {/* Header */}
      <header className="bg-white border-b border-blue-100 sticky top-0 z-30 shadow-sm">
        <div className="w-full mx-auto px-6 py-3.5 flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center text-white shadow-md shadow-blue-200">
              <RiShoppingCartLine className="w-5 h-5" />
            </div>
            <div>
              <h1 className="text-base font-bold text-blue-800 tracking-tight">
                Order Management
              </h1>
              <p className="text-[11px] text-blue-400 tracking-widest uppercase">
                Orders & Invoices
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="relative">
              <RiSearchLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-400" />
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search orders..."
                className="bg-blue-50 border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-700 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 w-52 transition"
              />
            </div>
            <button
              onClick={fetchOrders}
              disabled={loading}
              title="Refresh"
              className="w-9 h-9 flex items-center justify-center rounded-lg border border-blue-200 text-blue-400 hover:text-blue-600 hover:bg-blue-50 transition disabled:opacity-50"
            >
              <RiRefreshLine
                className={`w-4 h-4 ${loading ? "animate-spin" : ""}`}
              />
            </button>
            <button
              onClick={openCreate}
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold text-sm px-4 py-2 rounded-lg transition-all shadow-md shadow-blue-200"
            >
              <RiAddLine className="w-4 h-4" /> Create Order
            </button>
          </div>
        </div>
      </header>

      {/* Table */}
      <div className="w-full mx-auto px-6 pt-6 pb-10">
        <div className="bg-white border border-blue-100 rounded-2xl overflow-hidden shadow-sm">
          <div className="px-5 py-3.5 border-b border-blue-50 bg-blue-50/50 flex items-center justify-between">
            <span className="text-sm font-semibold text-blue-800 flex items-center gap-2">
              <RiShoppingCartLine className="w-4 h-4 text-blue-500" /> All
              Orders
            </span>
            <span className="text-xs text-blue-400">
              {filtered.length} record{filtered.length !== 1 ? "s" : ""}
            </span>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-blue-100 bg-blue-50/30">
                  {[
                    [RiFileCopyLine, "Invoice No"],
                    [RiUserLine, "Customer"],
                    [RiPhoneLine, "Phone"],
                    [RiBankLine, "Bank"],
                    [RiBuildingLine, "Seller Co."],
                    [RiGiftLine, "Items"],
                    [RiMoneyDollarCircleLine, "Total"],
                    [RiCalendarLine, "Date"],
                    [null, "Actions"],
                  ].map(([Icon, label], i) => (
                    <th key={i} className="px-4 py-3 text-left">
                      <span className="flex items-center gap-1.5 text-xs font-semibold text-blue-500 uppercase tracking-widest">
                        {Icon && <Icon className="w-3.5 h-3.5" />} {label}
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={9} className="py-20 text-center">
                      <div className="flex flex-col items-center gap-3 text-blue-400">
                        <AiOutlineLoading3Quarters className="w-7 h-7 animate-spin text-blue-500" />
                        <span className="text-sm">Loading orders…</span>
                      </div>
                    </td>
                  </tr>
                ) : filtered.length === 0 ? (
                  <tr>
                    <td colSpan={9} className="py-20 text-center">
                      <div className="flex flex-col items-center gap-3">
                        <div className="w-14 h-14 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center">
                          <RiShoppingCartLine className="w-7 h-7 text-blue-300" />
                        </div>
                        <span className="text-sm text-slate-400">
                          {search
                            ? "No orders match your search."
                            : "No orders found. Create one to get started."}
                        </span>
                      </div>
                    </td>
                  </tr>
                ) : (
                  filtered.map((order, i) => (
                    <tr
                      key={order._id || i}
                      className="border-b border-blue-50 hover:bg-blue-50/50 transition group"
                    >
                      <td className="px-4 py-3 font-mono text-xs font-semibold text-blue-600 whitespace-nowrap">
                        {order.invoiceNumber || "—"}
                      </td>
                      <td className="px-4 py-3 font-semibold text-slate-800 whitespace-nowrap">
                        {order.userName || "—"}
                      </td>
                      <td className="px-4 py-3 text-slate-600 whitespace-nowrap">
                        {order.phone || "—"}
                      </td>
                      <td className="px-4 py-3 text-slate-600 whitespace-nowrap text-xs">
                        {order.companyId?.bankName || "—"}
                      </td>
                      <td className="px-4 py-3 text-slate-600 whitespace-nowrap text-xs">
                        {order.sellerCompanyId?.companyName || "—"}
                      </td>
                      <td className="px-4 py-3">
                        <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-50 border border-blue-200 rounded-lg">
                          <RiGiftLine className="w-3.5 h-3.5 text-blue-500" />
                          <span className="text-xs font-semibold text-blue-700">
                            {order.products?.length || 0}
                          </span>
                        </div>
                      </td>
                      <td className="px-4 py-3 font-semibold text-slate-700 whitespace-nowrap">
                        ₹{order.grandTotal?.toLocaleString() || "0"}
                      </td>
                      <td className="px-4 py-3 text-slate-400 whitespace-nowrap text-xs">
                        {new Date(order.createdAt).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })}
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex gap-2">
                          <button
                            onClick={() =>
                              navigate(
                                `/admin/vendor/buyer-data-details/${order._id}`,
                              )
                            }
                            className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-emerald-50 border border-emerald-200 text-emerald-600 hover:bg-emerald-100 font-semibold transition"
                          >
                            <RiEyeLine className="w-3.5 h-3.5" /> View
                          </button>
                          <button
                            onClick={() => openEdit(order)}
                            className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 font-semibold transition"
                          >
                            <RiEditLine className="w-3.5 h-3.5" /> Edit
                          </button>
                          <button
                            onClick={() => openDelete(order)}
                            className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-red-50 border border-red-200 text-red-500 hover:bg-red-100 font-semibold transition"
                          >
                            <RiDeleteBinLine className="w-3.5 h-3.5" /> Delete
                          </button>
                          <button
                            onClick={() => generateInvoicePDF(order)}
                            className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-purple-50 border border-purple-200 text-purple-600 hover:bg-purple-100 font-semibold transition"
                          >
                            <RiFileTextLine className="w-3.5 h-3.5" />
                            PDF
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* ── Create Modal ── */}
      {modal === "create" && (
        <Modal title="Create New Order" onClose={closeModal} size="lg">
          <div className="space-y-4">
            <Field
              label="Invoice Number"
              name="invoiceNumber"
              value={form.invoiceNumber}
              onChange={handleChange}
              icon={RiFileCopyLine}
              placeholder="e.g. INV-202608-0001 (leave blank to auto-generate)"
            />
            <SelectField
              label="Main Bank (Buyer)"
              icon={RiBankLine}
              value={form.companyId}
              onChange={(e) =>
                handleChange({
                  target: { name: "companyId", value: e.target.value },
                })
              }
              required
            >
              <option value="">Select Bank</option>
              {banks.map((b) => (
                <option key={b._id} value={b._id}>
                  {b.bankName}
                </option>
              ))}
            </SelectField>

            <div className="grid grid-cols-2 gap-4">
              <Field
                label="Customer Name"
                name="userName"
                value={form.userName}
                onChange={handleChange}
                icon={RiUserLine}
                required
              />
              <Field
                label="Bank Phone"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                icon={RiPhoneLine}
                required
              />
            </div>
            <Field
              label="Bank Address"
              name="address"
              value={form.address}
              onChange={handleChange}
              icon={RiMapPinLine}
              as="textarea"
              required
            />

            <SelectField
              label="Seller Company"
              icon={RiBuildingLine}
              value={form.sellerCompanyId}
              onChange={(e) =>
                handleChange({
                  target: { name: "sellerCompanyId", value: e.target.value },
                })
              }
              required
            >
              <option value="">Select Company</option>
              {companies.map((c) => (
                <option key={c._id} value={c._id}>
                  {c.companyName}
                </option>
              ))}
            </SelectField>

            <div className="grid grid-cols-2 gap-4">
              <SelectField
                label="Bank Account"
                icon={RiBankLine}
                value={form.selectedBankAccount.accountNumber}
                onChange={handleBankAccountChange}
                disabled={!form.sellerCompanyId}
                required
              >
                <option value="">Select Bank Account</option>
                {selectedSellerCompany?.bankDetails?.map((bank, idx) => (
                  <option key={idx} value={bank.accountNumber}>
                    {bank.accountNumber} — {bank.ifscCode}
                  </option>
                ))}
              </SelectField>

              <SelectField
                label="Query Contact (Optional)"
                icon={RiUserStarLine}
                value={form.selectedQueryContact.contactPersonName}
                onChange={handleQueryContactChange}
                disabled={!form.sellerCompanyId}
              >
                <option value="">Select Contact</option>
                {selectedSellerCompany?.queryDetails?.map((contact, idx) => (
                  <option key={idx} value={contact.contactPersonName}>
                    {contact.contactPersonName} — {contact.phone}
                  </option>
                ))}
              </SelectField>
            </div>

            {form.selectedBankAccount.accountNumber && (
              <div className="bg-blue-50 border border-blue-100 rounded-lg px-4 py-3 text-xs text-slate-600 flex gap-6 flex-wrap">
                <span>
                  <span className="font-semibold text-blue-700">Account:</span>{" "}
                  {form.selectedBankAccount.accountNumber}
                </span>
                <span>
                  <span className="font-semibold text-blue-700">IFSC:</span>{" "}
                  {form.selectedBankAccount.ifscCode}
                </span>
                {form.selectedBankAccount.branchName && (
                  <span>
                    <span className="font-semibold text-blue-700">Branch:</span>{" "}
                    {form.selectedBankAccount.branchName}
                  </span>
                )}
              </div>
            )}

            <div className="border-t border-blue-100 pt-4">
              <div className="flex items-center justify-between mb-3">
                <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
                  Products
                </label>
                <button
                  type="button"
                  onClick={handleAddProductItem}
                  className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 font-semibold transition"
                >
                  <RiAddLine className="w-3.5 h-3.5" /> Add Product
                </button>
              </div>
              {form.products.map((item, idx) => (
                <OrderedProductField
                  key={idx}
                  index={idx}
                  item={item}
                  onChange={(v) => handleProductItemChange(idx, v)}
                  onRemove={
                    form.products.length > 1
                      ? () => handleRemoveProductItem(idx)
                      : null
                  }
                  allProducts={allProducts}
                />
              ))}
            </div>

            <Field
              label="Note (Optional)"
              name="note"
              value={form.note}
              onChange={handleChange}
              icon={RiStickyNoteLine}
              as="textarea"
            />

            {form.products.some(
              (p) => p.productId && parseInt(p.quantity) > 0,
            ) && (
              <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                <h4 className="font-semibold text-slate-700 mb-2">
                  Order Summary
                </h4>
                <div className="space-y-1 text-sm">
                  <div className="flex justify-between">
                    <span className="text-slate-500">Subtotal:</span>
                    <span className="font-semibold">
                      ₹{totals.subtotal.toLocaleString()}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-slate-500">Total CGST:</span>
                    <span className="font-semibold text-emerald-600">
                      ₹{totals.totalCgst.toLocaleString()}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-slate-500">Total SGST:</span>
                    <span className="font-semibold text-emerald-600">
                      ₹{totals.totalSgst.toLocaleString()}
                    </span>
                  </div>
                  <div className="border-t border-blue-200 pt-2 mt-2 flex justify-between">
                    <span className="font-semibold text-slate-700">
                      Grand Total:
                    </span>
                    <span className="font-bold text-lg text-blue-600">
                      ₹{totals.grandTotal.toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            )}

            <div className="flex justify-end gap-3 pt-4 border-t border-blue-100">
              <button
                onClick={closeModal}
                className="px-5 py-2 rounded-lg text-sm text-slate-500 border border-slate-200 hover:bg-slate-50 transition"
              >
                Cancel
              </button>
              <button
                onClick={handleCreate}
                disabled={actionLoading}
                className="flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold bg-blue-600 hover:bg-blue-700 text-white transition disabled:opacity-60"
              >
                {actionLoading ? (
                  <Spinner />
                ) : (
                  <RiCheckLine className="w-4 h-4" />
                )}
                Create Order
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* ── Edit Modal ── */}
      {modal === "edit" && (
        <Modal
          title={`Edit Order — ${selected?.invoiceNumber}`}
          onClose={closeModal}
          size="lg"
        >
          <div className="space-y-4">
            {/* Bank (Main Bank) */}
            <Field
              label="Invoice Number"
              name="invoiceNumber"
              value={form.invoiceNumber}
              onChange={handleChange}
              icon={RiFileCopyLine}
              required
            />
            <SelectField
              label="Main Bank (Buyer)"
              icon={RiBankLine}
              value={form.companyId}
              onChange={(e) =>
                handleChange({
                  target: { name: "companyId", value: e.target.value },
                })
              }
              required
            >
              <option value="">Select Bank</option>
              {banks.map((b) => (
                <option key={b._id} value={b._id}>
                  {b.bankName}
                </option>
              ))}
            </SelectField>

            {/* Customer Name & Phone */}
            <div className="grid grid-cols-2 gap-4">
              <Field
                label="Customer Name"
                name="userName"
                value={form.userName}
                onChange={handleChange}
                icon={RiUserLine}
                required
              />
              <Field
                label="Phone"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                icon={RiPhoneLine}
                required
              />
            </div>

            {/* Address */}
            <Field
              label="Address"
              name="address"
              value={form.address}
              onChange={handleChange}
              icon={RiMapPinLine}
              as="textarea"
              required
            />

            {/* Seller Company */}
            <SelectField
              label="Seller Company"
              icon={RiBuildingLine}
              value={form.sellerCompanyId}
              onChange={(e) =>
                handleChange({
                  target: { name: "sellerCompanyId", value: e.target.value },
                })
              }
              required
            >
              <option value="">Select Company</option>
              {companies.map((c) => (
                <option key={c._id} value={c._id}>
                  {c.companyName}
                </option>
              ))}
            </SelectField>

            {/* Bank Account & Query Contact */}
            <div className="grid grid-cols-2 gap-4">
              <SelectField
                label="Bank Account"
                icon={RiBankLine}
                value={form.selectedBankAccount.accountNumber}
                onChange={handleBankAccountChange}
                disabled={!form.sellerCompanyId}
                required
              >
                <option value="">Select Bank Account</option>
                {selectedSellerCompany?.bankDetails?.map((bank, idx) => (
                  <option key={idx} value={bank.accountNumber}>
                    {bank.accountNumber} — {bank.ifscCode}
                  </option>
                ))}
              </SelectField>

              <SelectField
                label="Query Contact (Optional)"
                icon={RiUserStarLine}
                value={form.selectedQueryContact.contactPersonName}
                onChange={handleQueryContactChange}
                disabled={!form.sellerCompanyId}
              >
                <option value="">Select Contact</option>
                {selectedSellerCompany?.queryDetails?.map((contact, idx) => (
                  <option key={idx} value={contact.contactPersonName}>
                    {contact.contactPersonName} — {contact.phone}
                  </option>
                ))}
              </SelectField>
            </div>

            {/* Selected bank account details */}
            {form.selectedBankAccount.accountNumber && (
              <div className="bg-blue-50 border border-blue-100 rounded-lg px-4 py-3 text-xs text-slate-600 flex gap-6 flex-wrap">
                <span>
                  <span className="font-semibold text-blue-700">Account:</span>{" "}
                  {form.selectedBankAccount.accountNumber}
                </span>
                <span>
                  <span className="font-semibold text-blue-700">IFSC:</span>{" "}
                  {form.selectedBankAccount.ifscCode}
                </span>
                {form.selectedBankAccount.branchName && (
                  <span>
                    <span className="font-semibold text-blue-700">Branch:</span>{" "}
                    {form.selectedBankAccount.branchName}
                  </span>
                )}
              </div>
            )}

            {/* Products section */}
            <div className="border-t border-blue-100 pt-4">
              <div className="flex items-center justify-between mb-3">
                <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
                  Products
                </label>
                <button
                  type="button"
                  onClick={handleAddProductItem}
                  className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 font-semibold transition"
                >
                  <RiAddLine className="w-3.5 h-3.5" /> Add Product
                </button>
              </div>
              {form.products.map((item, idx) => (
                <OrderedProductField
                  key={idx}
                  index={idx}
                  item={item}
                  onChange={(v) => handleProductItemChange(idx, v)}
                  onRemove={
                    form.products.length > 1
                      ? () => handleRemoveProductItem(idx)
                      : null
                  }
                  allProducts={allProducts}
                />
              ))}
            </div>

            {/* Note */}
            <Field
              label="Note (Optional)"
              name="note"
              value={form.note}
              onChange={handleChange}
              icon={RiStickyNoteLine}
              as="textarea"
            />

            {/* Order Summary */}
            {form.products.some(
              (p) => p.productId && parseInt(p.quantity) > 0,
            ) && (
              <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                <h4 className="font-semibold text-slate-700 mb-2">
                  Order Summary
                </h4>
                <div className="space-y-1 text-sm">
                  <div className="flex justify-between">
                    <span className="text-slate-500">Subtotal:</span>
                    <span className="font-semibold">
                      ₹{totals.subtotal.toLocaleString()}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-slate-500">Total CGST:</span>
                    <span className="font-semibold text-emerald-600">
                      ₹{totals.totalCgst.toLocaleString()}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-slate-500">Total SGST:</span>
                    <span className="font-semibold text-emerald-600">
                      ₹{totals.totalSgst.toLocaleString()}
                    </span>
                  </div>
                  <div className="border-t border-blue-200 pt-2 mt-2 flex justify-between">
                    <span className="font-semibold text-slate-700">
                      Grand Total:
                    </span>
                    <span className="font-bold text-lg text-blue-600">
                      ₹{totals.grandTotal.toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {/* Action Buttons */}
            <div className="flex justify-end gap-3 pt-4 border-t border-blue-100">
              <button
                onClick={closeModal}
                className="px-5 py-2 rounded-lg text-sm text-slate-500 border border-slate-200 hover:bg-slate-50 transition"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdate}
                disabled={actionLoading}
                className="flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold bg-blue-600 hover:bg-blue-700 text-white transition disabled:opacity-60"
              >
                {actionLoading ? (
                  <Spinner />
                ) : (
                  <RiCheckLine className="w-4 h-4" />
                )}
                Save Changes
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* ── Delete Modal ── */}
      {modal === "delete" && (
        <Modal title="Confirm Deletion" onClose={closeModal}>
          <div className="text-center py-4">
            <div className="w-16 h-16 rounded-full bg-red-50 border border-red-100 flex items-center justify-center mx-auto mb-4">
              <RiErrorWarningLine className="w-8 h-8 text-red-500" />
            </div>
            <p className="text-slate-700 font-semibold mb-1 text-base">
              Delete order #{selected?.invoiceNumber}?
            </p>
            <p className="text-slate-400 text-sm mb-6">
              This action cannot be undone. Stock will be restored.
            </p>
            <div className="flex justify-center gap-3">
              <button
                onClick={closeModal}
                className="px-6 py-2 rounded-lg text-sm text-slate-500 border border-slate-200 hover:bg-slate-50 transition"
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                disabled={actionLoading}
                className="flex items-center gap-2 px-6 py-2 rounded-lg text-sm font-semibold bg-red-500 hover:bg-red-600 text-white transition disabled:opacity-60"
              >
                {actionLoading ? (
                  <Spinner />
                ) : (
                  <RiDeleteBinLine className="w-4 h-4" />
                )}
                Delete Order
              </button>
            </div>
          </div>
        </Modal>
      )}

      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
}
